import { gsap } from 'gsap'
import { SplitText } from 'gsap/SplitText'

export const headlineTransitions = ($el, opts = {}) => {
  const elements = $el.querySelectorAll('h1, h2, h3')
  const fadeElements = $el.querySelectorAll('.js-fade-in')
  const imgElements = $el.querySelectorAll('.js-img-fade-in')

  elements.forEach(function (element) {

    let text = new SplitText(element, { type: 'words', wordsClass: 'px-1 md:px-2 lg:px-3 py-0 md:py-0' })

    element.setAttribute('aria-label', element.innerText)
    element.classList.add('word-spacing-0')

    gsap.from(imgElements, {
      opacity: 0,
      y:14,
      duration: 1,
      ease: "expo.out"
    })

    gsap.from(text.words, {
      delay: 0.25,
      opacity: 0,
      y:14,
      duration: 1.3,
      stagger: 0.05,
      ease: "expo.out"
    })

    gsap.from(fadeElements, {
      opacity: 0,
      y:14,
      duration: 1.3,
      delay: 0.75,
      stagger: 0.15,
      ease: "expo.out"
    })

  })
}

